import {
  customerMarketShopfrontApi,
  customerMarketShopfrontJobsApi
} from '@envato/foundation-types'

import {
  ActionTypes as FeaturedActionTypes,
  TypeKeys as FeaturedTypeKeys
} from '../actions/featurePage'

export interface IState {
  readonly featuredItems?: customerMarketShopfrontJobsApi.IBaseResult
  readonly featuredAuthors?: customerMarketShopfrontJobsApi.IFeaturedAuthorsResult
  readonly metadata: customerMarketShopfrontApi.ISeoMetadata | null
  readonly isLoading: boolean
}

const initialState: IState = {
  featuredItems: undefined,
  featuredAuthors: undefined,
  isLoading: false,
  metadata: null
}

export const reducer = (
  state = initialState,
  action: FeaturedActionTypes
): IState => {
  switch (action.type) {
    case FeaturedTypeKeys.GET_FEATURED_PAGE_API_REQUEST:
      return {
        ...state,
        featuredItems: undefined,
        isLoading: true
      }

    case FeaturedTypeKeys.GET_FEATURED_PAGE_API_SUCCESS:
      const featuredItems = action.payload.featured_items
      const featuredAuthors = action.payload.featured_authors
      const metadata = action.payload.metadata

      return {
        featuredItems,
        featuredAuthors,
        metadata,
        isLoading: false
      }

    case FeaturedTypeKeys.GET_FEATURED_PAGE_API_FAIL:
      return {
        ...state,
        isLoading: false
      }

    default:
      return state
  }
}
